import React from "react"
import Table from "../../../components/common/Table"
import MaterialTable from "material-ui/Table"
import { TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import FontIcon from "material-ui/FontIcon"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import PayrollTimeByHierarchyEmployeeRow from "./PayrollTimeByHierarchyEmployeeRow"
import PayrollByHierarchyTableLockedColumn from "../../../components/payroll/PayrollByHierarchyTableLockedColumn"
import PayrollByHierarchyTableClosedColumn from "../../../components/payroll/PayrollByHierarchyTableClosedColumn"
import { green500 } from "material-ui/styles/colors"
import { IDateRange, IPayrollTimeHierarchy, IPayrollTimeHierarchyEmployee, ITimeTotals } from "../../../models"
import AccountStore from "../../../stores/AccountStore"
import UserCheck from "../../../../assets/icons/user-check"
import AppStateStore from "../../../stores/AppStateStore"
import * as payGroupAndTypeHelper from "../../../helpers/payGroupAndTypeHelper"
import { grey50, deepOrangeA700 } from "material-ui/styles/colors"

interface IProps {
	payrollDates: IDateRange
	payrollTimeHierarchies: IPayrollTimeHierarchy[]
	timeTotals: ITimeTotals
	showTimecardPopup(employeeId: string, referenceDate: string): void
	handleSelectPayrollHierarchy(selectedPayrollHierarchies: IPayrollTimeHierarchy[]): void
	handleSelectEmployee(selectedEmployees: IPayrollTimeHierarchyEmployee[], unselectedEmployees: IPayrollTimeHierarchyEmployee[]): void
	reloadTimeCard: () => void
}
interface IState {
	expandRow: number
	selectedPayrollHierarchies: IPayrollTimeHierarchy[]
}

export default class PayrollTimeByHierarchyTable extends React.Component<IProps, IState> {
	private PayrollTimeByHierarchyEmployeeRow = []
	constructor(props) {
		super(props)
		this.state = {
			expandRow: -1,
			selectedPayrollHierarchies: []
		}
		autobind(this)
	}

	handleClickRow(clickedRow) {
		this.setState({
			expandRow: clickedRow === this.state.expandRow ? -1 : clickedRow
		})
	}

	handleSelectPayrollHierarchies(selectedPayrollHierarchies: IPayrollTimeHierarchy[]) {
		let newSelectedPayrollHierarchies: IPayrollTimeHierarchy[] = []
		let unSelectedPayrollHierarchies: IPayrollTimeHierarchy[] = []
		this.props.payrollTimeHierarchies.forEach(i => {
			const originalSelected = this.state.selectedPayrollHierarchies.find(j => j.HierarchyItem.Id === i.HierarchyItem.Id && j.PayrollPayGroupId === i.PayrollPayGroupId)
			const selected = selectedPayrollHierarchies.find(j => j.HierarchyItem.Id === i.HierarchyItem.Id && j.PayrollPayGroupId === i.PayrollPayGroupId)
			originalSelected && !selected &&
				unSelectedPayrollHierarchies.push(i)
			!originalSelected && selected &&
				newSelectedPayrollHierarchies.push(i)
		})

		newSelectedPayrollHierarchies.forEach(i => {
			const rowNumber = this.getPayrollHierarchyRowNumber(i)
			this.PayrollTimeByHierarchyEmployeeRow[rowNumber].setState({
				selectedEmployees: i.PayrollEmployees
			})
			this.props.handleSelectEmployee(i.PayrollEmployees, [])
		})

		unSelectedPayrollHierarchies.forEach(i => {
			const rowNumber = this.getPayrollHierarchyRowNumber(i)
			this.PayrollTimeByHierarchyEmployeeRow[rowNumber].setState({
				selectedEmployees: []
			})
			this.props.handleSelectEmployee([], i.PayrollEmployees)
		})

		this.setSelectedPayrollHierarchies(selectedPayrollHierarchies)
	}

	getPayrollHierarchyRowNumber(payrollHierarchy: IPayrollTimeHierarchy) {
		return this.props.payrollTimeHierarchies.findIndex(i => i.HierarchyItem.Id === payrollHierarchy.HierarchyItem.Id && i.PayrollPayGroupId === payrollHierarchy.PayrollPayGroupId)
	}

	setSelectedPayrollHierarchies(selectedPayrollHierarchies) {
		this.setState({ selectedPayrollHierarchies })
		this.props.handleSelectPayrollHierarchy(selectedPayrollHierarchies)
	}

	handleSelectEmployee(payrollHierarchyIndex, selectedEmployees, unselectedEmployees) {
		const payrollHierarchy = this.props.payrollTimeHierarchies[payrollHierarchyIndex]
		let selectedPayrollHierarchies = this.state.selectedPayrollHierarchies.slice()
		if (unselectedEmployees.length === 0) {
			if (!selectedPayrollHierarchies.find((item) => item.HierarchyItem.Id === payrollHierarchy.HierarchyItem.Id && item.PayrollPayGroupId === payrollHierarchy.PayrollPayGroupId)) {
				selectedPayrollHierarchies.push(payrollHierarchy)
			}
		} else {
			selectedPayrollHierarchies = selectedPayrollHierarchies.filter((item) => item.HierarchyItem.Id !== payrollHierarchy.HierarchyItem.Id || item.PayrollPayGroupId !== payrollHierarchy.PayrollPayGroupId)
		}
		this.setSelectedPayrollHierarchies(selectedPayrollHierarchies)
		this.props.handleSelectEmployee(selectedEmployees, unselectedEmployees)
	}

	getMissingPunchCount(hierarchyData: IPayrollTimeHierarchy) {
		let missingPunchCount = 0
		hierarchyData.PayrollEmployees.forEach(employeeData => {
			employeeData.JobCostingSummaryList.forEach(dayData => {
				dayData.PayrollPunchSets.forEach((punchSet) => {
					if (!punchSet.PunchOutId) missingPunchCount++
				})
			})
		})
		return missingPunchCount
	}

	render() {
		const { payrollTimeHierarchies, timeTotals } = this.props
		const { expandRow } = this.state
		var formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
		});

		return (
			<Table
				items={payrollTimeHierarchies}
				selectedItems={this.state.selectedPayrollHierarchies}
				wrapperStyle={{ width: "fit-content", overflow: "unset" }}
				handleSelect={this.handleSelectPayrollHierarchies}
				uniqueIdentifier="PayrollStatusDocId"
			>
				<TableHeader>
					<TableRow className="ShortSelectBoxTableHeader">
						<TableHeaderColumn style={styles.noteIconCol} />
						<TableHeaderColumn className="TextOverflow" title={strings.Hierarchy_Name} style={styles.hierarchyCol}>{strings.Hierarchy_Name}</TableHeaderColumn>
						{AccountStore.getEnablePayGroupAssignEmployeeLevel() &&
							<TableHeaderColumn className="TextOverflow" title={strings.Pay_Group_Name} style={styles.payGroupCol}>{strings.Pay_Group_Name}</TableHeaderColumn>
						}
						<TableHeaderColumn />
						{AccountStore.getShowPayrollRates() &&
							<TableHeaderColumn className="TextOverflow" title={`${strings.Pay} ${strings.Amount}`} style={styles.amountCol}>{strings.Pay} {strings.Amount}</TableHeaderColumn>
						}
						{AccountStore.getExpensesEnabled() && AccountStore.getExpenseIsPayrollTime() &&
							<TableHeaderColumn className="TextOverflow" title={strings.Amount} style={styles.amountCol}>{strings.Amount}</TableHeaderColumn>
						}
						<TableHeaderColumn className="TextOverflow" title={strings.TotalHours} style={styles.hoursCol}>{strings.TotalHours}</TableHeaderColumn>
						<TableHeaderColumn className="TextOverflow" title={strings.Reg_Hours} style={styles.hoursCol}>{strings.Reg_Hours}</TableHeaderColumn>
						<TableHeaderColumn className="TextOverflow" title={strings.OT_Hours} style={styles.hoursCol}>{strings.OT_Hours}</TableHeaderColumn>
						{!AccountStore.getHideOT2() &&
							<TableHeaderColumn className="TextOverflow" title={strings.OT2_Hours} style={styles.hoursCol}>{strings.OT2_Hours}</TableHeaderColumn>
						}
						{timeTotals.PayTypeTotals.map((payTypeTotal, index) =>
							<TableHeaderColumn key={index} style={styles.hoursCol}>
								<span className="TextOverflow" title={payTypeTotal.PayTypeName}>{payTypeTotal.PayTypeCode} </span>
							</TableHeaderColumn>
						)}
						<TableHeaderColumn className="TextOverflow" title={strings.Open_Punches} style={styles.missingPunchedCol}>{strings.Open_Punches}</TableHeaderColumn>
						{AccountStore.getEmployeeApproveTimecardEnabled() &&
							<TableHeaderColumn className="TextOverflow" title={strings.Employee} style={styles.approveCol}>{strings.Employee}</TableHeaderColumn>
						}
						<TableHeaderColumn className="TextOverflow" title={strings.Supervisor} style={styles.approveCol}>{strings.Supervisor}</TableHeaderColumn>
						<TableHeaderColumn className="TextOverflow" title={strings.Validation_msgs} style={{ ...styles.approveCol, width: 100 }}>
							<div
								style={{
									position: "absolute", top: 3, left: 87, minWidth: 20, minHeight: 20, fontSize: 14, fontWeight: 500,
									backgroundColor: deepOrangeA700, color: grey50, borderRadius: 100, display: "flex", justifyContent: "center", alignItems: "center", zIndex: 100
								}}
							>

								{payrollTimeHierarchies.reduce((prev, next) => prev + next.TotalValidationMessages, 0)}
							</div>
							{strings.Validation_msgs}
						</TableHeaderColumn>
						{AccountStore.getExtSupApproveTimecardEnabled() &&
							<TableHeaderColumn className="TextOverflow" title={strings.External} style={styles.approveCol}>{strings.External}</TableHeaderColumn>
						}
						{AccountStore.getEnableEmployeeLock() &&
							<TableHeaderColumn className="TextOverflow" title={strings.EMP_Locked} style={styles.iconCol}>{strings.EMP_Locked}</TableHeaderColumn>
						}
						<TableHeaderColumn className="TextOverflow" title={strings.Locked} style={styles.iconCol}>{strings.Locked}</TableHeaderColumn>
						{AccountStore.getAccrualsTimeoffEnabled() &&
							<TableHeaderColumn className="TextOverflow" title={strings.Closed} style={styles.iconCol}>{strings.Closed}</TableHeaderColumn>
						}
						<TableHeaderColumn className="TextOverflow" title={strings.Exported} style={styles.iconCol}>{strings.Exported}</TableHeaderColumn>
					</TableRow>
				</TableHeader>
				<TableBody deselectOnClickaway={false}>
					{payrollTimeHierarchies.map((hierarchyData, index) => {
						const expandState = index === expandRow
						const selected = this.state.selectedPayrollHierarchies.find((item) => item.HierarchyItem.Id === hierarchyData.HierarchyItem.Id && item.PayrollPayGroupId === hierarchyData.PayrollPayGroupId) ? true : false
						const emptyEmployeeCount = hierarchyData.PayrollEmployees.filter(i => i.JobCostingSummaryList.length === 0).length
						return (
							<TableRow key={index} className="ShortSelectBoxTableRow" selected={selected}>
								<TableRowColumn style={{ paddingLeft: 0, paddingRight: 0 }}>
									<MaterialTable style={{ backgroundColor: "none" }} onCellClick={() => this.handleClickRow(index)}>
										<TableBody displayRowCheckbox={false}>
											<TableRow data-intercom-target={index === 0 && "menu-Payroll-PayrollTimeHierarchyTable-openItemDetails"} style={{ cursor: "pointer", height: 48, borderBottom: expandState ? "solid 2px #cccccc" : "none" }}>
												<TableRowColumn style={styles.noteIconCol}>
													<FontIcon
														data-intercom-target={`menu-payroll-Btn-OpenNotes_${index}`}
														className="fa fa-info-circle"
														style={{ fontSize: 16, color: "#777777", cursor: "pointer" }}
														onClick={e => {
															e.stopPropagation()
															AppStateStore.setNoteDrawerContent({
																drawerTitle: `${strings.Payroll} "${hierarchyData.HierarchyItem.Label}"`,
																objectData: {
																	ObjectId: hierarchyData.PayrollStatusDocId
																},
																objectName: "Payroll",
																dataType: "payroll",
															})
														}}
													/>
												</TableRowColumn>
												<TableRowColumn style={{ ...styles.hierarchyCol, fontWeight: emptyEmployeeCount > 0 && "bolder" }}>{hierarchyData.HierarchyItem.Label}</TableRowColumn>
												{AccountStore.getEnablePayGroupAssignEmployeeLevel() &&
													<TableRowColumn style={{ ...styles.payGroupCol, fontWeight: emptyEmployeeCount > 0 && "bolder" }}>
														{hierarchyData.PayrollPayGroupId ?
															payGroupAndTypeHelper.getPayGroupById(hierarchyData.PayrollPayGroupId).Name :
															strings.Default_PayGroup_of_Payroll_Hierarchy
														}
													</TableRowColumn>
												}
												<TableRowColumn />
												{AccountStore.getShowPayrollRates() &&
													<TableRowColumn style={styles.amountCol}>{formatter.format(hierarchyData.TimeTotals && hierarchyData.TimeTotals.TotalPay)}</TableRowColumn>
												}
												{AccountStore.getExpensesEnabled() && AccountStore.getExpenseIsPayrollTime() &&
													<TableRowColumn style={styles.amountCol}>{formatter.format(hierarchyData.TimeTotals && hierarchyData.TimeTotals.TotalAmount)}</TableRowColumn>
												}
												<TableRowColumn style={styles.hoursCol}>{hierarchyData.TimeTotals && hierarchyData.TimeTotals.TotalProductiveHours}</TableRowColumn>
												<TableRowColumn style={styles.hoursCol}>{hierarchyData.TimeTotals && hierarchyData.TimeTotals.RegularHours}</TableRowColumn>
												<TableRowColumn style={styles.hoursCol}>{hierarchyData.TimeTotals && hierarchyData.TimeTotals.OvertimeHours}</TableRowColumn>
												{!AccountStore.getHideOT2() &&
													<TableRowColumn style={styles.hoursCol}>{hierarchyData.TimeTotals && hierarchyData.TimeTotals.DoubleOvertimeHours}</TableRowColumn>
												}
												{timeTotals.PayTypeTotals.map((payTypeTotalType, index) => {
													const payTypeTotal = hierarchyData.TimeTotals.PayTypeTotals.find(payType => payType.PayTypeId === payTypeTotalType.PayTypeId)
													return (
														<TableRowColumn style={styles.hoursCol} key={index}>{payTypeTotal && payTypeTotal.TotalHours}</TableRowColumn>
													)
												})}
												<TableRowColumn style={styles.missingPunchedCol}>{this.getMissingPunchCount(hierarchyData)}</TableRowColumn>
												{AccountStore.getEmployeeApproveTimecardEnabled() &&
													<TableRowColumn style={styles.approveCol}>
														{hierarchyData.TotalEmployees === (hierarchyData.TotalEmpApprovedEmployees - emptyEmployeeCount) &&
															<UserCheck color={green500} width={17.5} height={14} />
														}
													</TableRowColumn>
												}
												<TableRowColumn style={styles.approveCol}>
													{hierarchyData.TotalApprovedEmployees === (hierarchyData.TotalEmployees - emptyEmployeeCount) &&
														<FontIcon className="fa fa-check" style={{ fontSize: 18, color: green500 }} />
													}
												</TableRowColumn>
												<TableRowColumn style={{ ...styles.approveCol, width: 100, ...(hierarchyData.TotalValidationMessages > 0 && { color: "red" }) }}>{hierarchyData.TotalValidationMessages || "0"}</TableRowColumn>
												{AccountStore.getExtSupApproveTimecardEnabled() &&
													<TableRowColumn style={styles.approveCol}>
														{hierarchyData.TotalEmployees === (hierarchyData.TotalExtSupApprovedEmployees - emptyEmployeeCount) &&
															<FontIcon className="fa fa-check-double" style={{ fontSize: 14, color: green500 }} />
														}
													</TableRowColumn>
												}
												{AccountStore.getEnableEmployeeLock() &&
													<TableRowColumn style={styles.iconCol}>
														{hierarchyData.EmpLockedData && hierarchyData.EmpLockedData.IsLocked &&
															<PayrollByHierarchyTableLockedColumn
																employeeLock
																keyStr={`emptime${index}`}
																lockedData={hierarchyData.EmpLockedData}
															/>
														}
													</TableRowColumn>
												}
												<TableRowColumn style={styles.iconCol}>
													{hierarchyData.LockedData && hierarchyData.LockedData.IsLocked &&
														<PayrollByHierarchyTableLockedColumn keyStr={`time${index}`} lockedData={hierarchyData.LockedData} />
													}
												</TableRowColumn>
												{AccountStore.getAccrualsTimeoffEnabled() &&
													<TableRowColumn style={styles.iconCol}>
														{hierarchyData.ClosedData &&
															hierarchyData.ClosedData.IsClosed &&
															<PayrollByHierarchyTableClosedColumn
																keyStr={`time${index}`}
																payrollStatusDocId={hierarchyData.PayrollStatusDocId}
																closedData={hierarchyData.ClosedData}
															/>
														}
													</TableRowColumn>
												}
												<TableRowColumn style={styles.iconCol}>
													{(hierarchyData.TotalEmployees - emptyEmployeeCount) === hierarchyData.TotalExportedEmployees &&
														<FontIcon className="fa fa-check" style={{ fontSize: 18, color: green500 }} />
													}
												</TableRowColumn>
											</TableRow>
											<TableRow style={{ height: expandState ? 48 : 0 }}>
												<TableRowColumn
													colSpan={10 +
														(AccountStore.getHideOT2() ? 0 : 1) +
														(timeTotals && timeTotals.PayTypeTotals ? timeTotals.PayTypeTotals.length : 0) +
														(AccountStore.getEmployeeApproveTimecardEnabled() ? 1 : 0) +
														(AccountStore.getExtSupApproveTimecardEnabled() ? 1 : 0) +
														(AccountStore.getAccrualsTimeoffEnabled() ? 1 : 0) +
														(AccountStore.getShowPayrollRates() ? 1 : 0) +
														(AccountStore.getExpensesEnabled() && AccountStore.getExpenseIsPayrollTime() ? 1 : 0) +
														(AccountStore.getEnableEmployeeLock() ? 1 : 0)
													}
													style={{ height: expandState ? 48 : 0, padding: expandState ? "50px 0px 50px 0px" : 0 }}
												>
													<div onClick={(e) => e.stopPropagation()}>
														<PayrollTimeByHierarchyEmployeeRow
															ref={(elem) => this.PayrollTimeByHierarchyEmployeeRow[index] = elem}
															viewPayrollByJob={false}
															payrollDates={this.props.payrollDates}
															employees={hierarchyData.PayrollEmployees}
															timeTotals={hierarchyData.TimeTotals}
															payrollHierarchyLockedData={hierarchyData.LockedData}
															showTimecardPopup={this.props.showTimecardPopup}
															expandState={expandState}
															payrollHierarchyIndex={index}
															handleSelectEmployee={this.handleSelectEmployee}
															reloadTimeCard={this.props.reloadTimeCard}
														/>
													</div>
												</TableRowColumn>
											</TableRow>
										</TableBody>
									</MaterialTable>
								</TableRowColumn>
							</TableRow>
						)
					})}
				</TableBody>
			</Table>
		)
	}
}

const styles = {
	hierarchyCol: {
		width: 200,
		paddingLeft: 10,
		paddingRight: 10
	},
	payGroupCol: {
		width: 100,
		paddingLeft: 10,
		paddingRight: 10
	},
	amountCol: {
		width: 90,
		paddingLeft: 5,
		paddingRight: 5
	},
	hoursCol: {
		width: 60,
		paddingLeft: 5,
		paddingRight: 5
	},
	approveCol: {
		width: 70,
		textAlign: "center",
		paddingLeft: 5,
		paddingRight: 5
	},
	iconCol: {
		width: 40,
		textAlign: "center",
		paddingLeft: 5,
		paddingRight: 5
	},
	missingPunchedCol: {
		width: 80,
		paddingLeft: 5,
		paddingRight: 5
	},
	noteIconCol: {
		width: 15,
		textAlign: "center",
		paddingLeft: 3,
		paddingRight: 3
	}
}
